import { makeAutoObservable } from 'mobx';
import { validateUnderlyingPriceTrail } from './validateUnderlyingPriceTrail';

export class UnderlyingPriceTrailData {
  amount = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }
  resetToDefaults = () => {
    this.amount = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateUnderlyingPriceTrail(this.amount);
    return result;
  };
  returnJson = () => {
    return {
      amount: this.amount,
    };
  };

  //specific methods
  setAmount = (number) => {
    this.amount = number;
  };
}
